import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative bg-brand-dark text-white pt-20 pb-24 overflow-hidden" data-id="element-31">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-yellow/5 rounded-full blur-[120px] pointer-events-none" data-id="element-32" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-33">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-34">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-35">
            <div className="inline-block bg-red-600 text-white font-bold px-3 py-1 rounded text-sm uppercase tracking-wider mb-6" data-id="element-36">
              Emergency Turnover Zone
            </div>

            <h1 className="text-5xl sm:text-6xl lg:text-7xl leading-[1.1] mb-6 text-balance" data-id="element-37">
              THE <span className="text-brand-yellow" data-id="element-38">48-HOUR</span> AIRBNB
              CLEANUP PROTOCOL
            </h1>

            <h2 className="text-xl sm:text-2xl font-body font-semibold text-gray-300 mb-8 leading-snug" data-id="element-39">
              The Step-By-Step Emergency System to Finish a 5-Star Turnover in
              Under 120 Minutes{' '}
              <span className="italic text-gray-400" data-id="element-40">
                (Even If You're Doing It Entirely Alone).
              </span>
            </h2>

            <div className="bg-white/5 border border-white/10 p-6 rounded-xl mb-10" data-id="element-41">
              <p className="text-gray-300 leading-relaxed" data-id="element-42">
                <strong className="text-white" data-id="element-43">
                  You just got the notification. "Instant Booked."
                </strong>{' '}
                A guest is arriving in three hours, and your property is a
                disaster from the last checkout. Your heart sinks because you
                know the local cleaning crews won't pick up the phone, and a
                single "dirty house" review could tank your listing's ranking
                for months.
              </p>
              <p className="text-gray-300 leading-relaxed mt-4" data-id="element-44">
                You don't have time to be a perfectionist, but you can't afford
                to be sloppy. You are officially in the "Emergency Turnover
                Zone."
              </p>
            </div>

            <Button subtext="Instant PDF Access. Save your next turnover." onClick={() => {
            document.getElementById('offer')?.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }} data-id="element-45">
              Download the Protocol Now — $6.36
            </Button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative lg:h-[600px] flex items-center justify-center" data-id="element-46">
            <div className="absolute inset-0 bg-gradient-to-tr from-brand-yellow/20 to-transparent rounded-3xl blur-3xl" data-id="element-47" />
            <img src="https://cdn.magicpatterns.com/uploads/6zswByJzs2XWdCc2bmvTJD/heylloyd-image-1778928817369.png" alt="The 48-Hour Airbnb Cleanup Protocol Digital Product" className="relative z-10 w-full max-w-lg mx-auto drop-shadow-2xl rounded-xl" data-id="element-48" />
          </motion.div>
        </div>
      </div>
    </section>;
}